// 南通各区县宣传视频数据
export const nantongVideos = [
  {
    id: 1,
    name: '海安',
    nameEn: 'haian',
    url: 'https://1500000890.vod2.myqcloud.com/438181a1vodtranscq1500000890/3cb4d4ce5145403719555537839/v.f100030.mp4'
  },
  {
    id: 2,
    name: '如皋',
    nameEn: 'rugao',
    url: 'https://1500000890.vod2.myqcloud.com/438181a1vodtranscq1500000890/3f193e605145403719555642225/v.f100030.mp4'
  },
  {
    id: 3,
    name: '如东',
    nameEn: 'rudong',
    url: 'https://1500000890.vod2.myqcloud.com/438181a1vodtranscq1500000890/8c89d9db5145403719522362803/v.f100030.mp4'
  },
  {
    id: 4,
    name: '启东',
    nameEn: 'qidong',
    url: 'https://1500000890.vod2.myqcloud.com/438181a1vodtranscq1500000890/fbe859aa5145403719615390778/v.f100030.mp4'
  },
  {
    id: 5,
    name: '崇川',
    nameEn: 'chongchuan',
    url: 'https://1500000890.vod2.myqcloud.com/438181a1vodtranscq1500000890/096d00a95145403719615928671/v.f100030.mp4'
  },
  {
    id: 6,
    name: '通州',
    nameEn: 'tongzhou',
    url: 'https://1500000890.vod2.myqcloud.com/438181a1vodtranscq1500000890/37e37b7a5145403719555312261/v.f100030.mp4'
  },
  {
    id: 7,
    name: '海门',
    nameEn: 'haimen',
    url: 'https://1500000890.vod2.myqcloud.com/438181a1vodtranscq1500000890/abcd12345145403719555537840/v.f100030.mp4'
  },
  {
    id: 8,
    name: '开发区',
    nameEn: 'kaifaqu',
    url: 'https://1500000890.vod2.myqcloud.com/438181a1vodtranscq1500000890/fdc0621e5145403719615423157/v.f100030.mp4'
  },
  {
    id: 9,
    name: '苏锡通',
    nameEn: 'suxitong',
    url: 'https://1500000890.vod2.myqcloud.com/438181a1vodtranscq1500000890/8c8a51df5145403719522363374/v.f100030.mp4'
  },
  {
    id: 10,
    name: '通州湾',
    nameEn: 'tongzhouwan',
    url: 'https://1500000890.vod2.myqcloud.com/438181a1vodtranscq1500000890/37d429c35145403719555307491/v.f100030.mp4'
  }
];